import { useState, useRef } from 'react';
import { Upload, X, Loader2 } from 'lucide-react';
import { getImageUrl } from '../lib/utils-img';
import API from '../lib/api';
import { toast } from 'sonner';

export default function ImageUpload({ value, onChange, label = 'Upload Image', className = '' }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { toast.error('File too large (max 10MB)'); return; }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await API.post('/admin/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(data.url);
      toast.success('Image uploaded');
    } catch (err) { toast.error(err.response?.data?.detail || 'Upload failed'); }
    setUploading(false);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div className={className}>
      {label && <label className="text-[10px] uppercase tracking-widest text-white/35 mb-1.5 block font-medium">{label}</label>}
      {value ? (
        <div className="relative group rounded-xl overflow-hidden border border-white/[0.08] bg-[#1a1a1a]">
          <img src={getImageUrl(value)} alt="" className="w-full h-40 object-cover" />
          <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
            <button type="button" onClick={() => inputRef.current?.click()} className="bg-white/90 text-stone-800 text-xs px-3 py-1.5 rounded-lg font-medium hover:bg-white">Replace</button>
            <button type="button" onClick={() => onChange('')} className="bg-red-500/90 text-white text-xs px-3 py-1.5 rounded-lg font-medium hover:bg-red-500 flex items-center gap-1"><X className="w-3 h-3" />Remove</button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
          className="w-full h-40 border-2 border-dashed border-white/[0.10] rounded-xl flex flex-col items-center justify-center gap-2 text-white/25 hover:border-gold hover:text-gold transition-colors bg-[#1a1a1a]"
          data-testid="image-upload-btn"
        >
          {uploading ? <Loader2 className="w-6 h-6 animate-spin" /> : <Upload className="w-6 h-6" />}
          <span className="text-xs">{uploading ? 'Uploading...' : 'Click to upload'}</span>
        </button>
      )}
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
    </div>
  );
}
